module.exports = __webpack_public_path__ + "static/media/Developer.9a682a2c.jpg";